var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.is_important)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"mx-1",attrs:{"color":_vm.item.is_important ? 'orange lighten-1' : 'grey',"icon":"","small":""}},on),[_c('v-icon',[_vm._v("mdi-flag")])],1)]}}],null,false,1895776205)},[_vm._v(" "+_vm._s(_vm.$t("important"))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }